'use strict';
import {combineReducers} from 'redux';
import {reactReduxModal as chatChannelModal} from '../redux/chatChannelModal';
import {reduxList as chatMessageList} from '../redux/chatMessageList';
import {reduxList as chatSubscriberList} from '../redux/chatSubscriberList';
import {
  CHAT_MESSAGE_LIST_NAME,
  CHAT_MODAL_LIST_NAME,
  CHAT_SUBSCRIBERS_LIST_NAME,
  USER_SUBSCRIPTIONS_LIST_NAME,
  VIDEO_CHAT_START_NAME,
  VIDEO_SESSION_NAME,
} from '../redux/state';
import {reduxList as userSubscriptions} from '../redux/userSubscriptions';
import {videoChatStartModal} from '../redux/videoChatStartModal';
import {videoSessionRequests} from '../redux/videoSessionRequests';


export * from './state';

export const chat = combineReducers({
  [CHAT_MESSAGE_LIST_NAME]: chatMessageList.reducers.reducer,
  [CHAT_MODAL_LIST_NAME]: chatChannelModal.reducers.reducer,
  [CHAT_SUBSCRIBERS_LIST_NAME]: chatSubscriberList.reducers.reducer,
  [USER_SUBSCRIPTIONS_LIST_NAME]: userSubscriptions.reducers.reducer,
  [VIDEO_CHAT_START_NAME]: videoChatStartModal.reducers.reducer,
  [VIDEO_SESSION_NAME]: videoSessionRequests.reducers.reducer,
});



// WEBPACK FOOTER //
// ./src/js/comments/reducers/index.js